















































































































































import { Component, Ref, Vue } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import manageService from "@/services/manage.service"
import FileCardList from "@/components/file-card-list/index.vue"
import { ReleaseColumns } from "./constant"
import { cloneDeep, pick } from "lodash"
import { FormModel } from "ant-design-vue"
import AdjustRecords from "./adjustRecords.vue"

@Component({
    components: {
        PageHeader,
        FileCardList,
        AdjustRecords
    }
})
export default class IterationList extends Vue {
    @Ref("basicInformation")
    basicForm: FormModel

    @Ref("adjustForm")
    adjustForm: FormModel

    detailInfo: any = {}
    textTips = false
    activeTab = "basic"
    releaseData: any = []
    product_version_id: number = null
    scheduleData: any = []
    form: any = {
        product_version_id: "",
        version_number: "",
        version_type: "",
        plan_lock_date: "",
        lock_time: "",
        version_code: "",
        version_name: "",
        adjustment_remark: ""
    }

    labelCol = { style: "width: 140px; float: left" }
    wrapperCol = { style: "margin-left: 140px" }
    adjustInstruct: { visible: boolean; text: string } = {
        visible: false,
        text: ""
    }

    loading = false

    get productName() {
        const { full_name } = this.detailInfo
        return `${full_name || "-"}`
    }

    get releaseColumns() {
        const Supply = {
            title: "发布时间",
            dataIndex: "release_time",
            key: "release_time",
            scopedSlots: { customRender: "release_time" }
        }

        const ReleaseColumnsEdit = ReleaseColumns.filter(el => el.dataIndex != "release_time")
        ReleaseColumnsEdit.push(Supply)
        return ReleaseColumnsEdit
    }

    get rules() {
        return {
            version_number: [{ required: true, message: "必填", trigger: "blur" }],
            version_type: [{ required: true, message: "必填", trigger: "blur" }],
            plan_lock_date: [{ required: true, message: "必填", trigger: "blur" }],
            lock_time: [{ required: true, message: "必填", trigger: "blur" }],
            version_code: [{ required: true, message: "必填", trigger: "blur" }],
            version_name: [{ required: true, message: "必填", trigger: "blur" }],
            adjustment_remark: [{ required: true, message: "必填", trigger: "blur" }]
        }
    }
    created() {
        this.product_version_id = Number(this.$route.query.id)
        this.activeTab = this.$route.query.activeTab || "basic"
        this.getDetail()
    }

    goBack() {
        this.$router.go(-1)
    }
    // 编辑发布时间
    async releaseInterface() {
        try {
            const cloneReleaseData = cloneDeep(this.releaseData)
            const list = cloneReleaseData.map((item: any) => ({
                id: item.id,
                release_time: item.release_time
            }))
            await manageService.editReleaseTime({ list: list })
            this.$message.success("提交成功！")
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }
    // 基本信息-版本编辑校验
    async basicInterface() {
        try {
            await this.basicForm.validate()
            const formClone = cloneDeep(this.form)
            this.formSubmit = pick(formClone, [
                "product_version_id",
                "version_number",
                "version_type",
                "plan_lock_date",
                "lock_time",
                "version_code",
                "version_name"
            ])
            const payload = {
                ...this.formSubmit,
                adjustment_remark: this.adjustInstruct.text,
                version_type: this.formSubmit.version_type == "功能更新" ? 1 : 2
            }

            const res: any = await manageService.versionEditCheck(payload)
            if (res) {
                this.textTips = false
                this.adjustInstruct.visible = true
            } else {
                this.textTips = true
            }
        } catch (error) {
            if (error) {
                this.$message.error(`${error}`)
            }
        }
    }

    onSubmit(otherTab: string) {
        if (otherTab == "basic") {
            this.basicInterface()
        } else if (otherTab == "release") {
            this.releaseInterface()
        }
    }

    formSubmit: any
    async onSubmitText() {
        try {
            await this.adjustForm.validate()
            const payload = {
                ...this.formSubmit,
                adjustment_remark: this.adjustInstruct.text,
                version_type: this.formSubmit.version_type == "功能更新" ? 1 : 2
            }
            await manageService.versionEdit(payload)
            this.adjustInstruct.text = ""
            this.$message.success("提交成功！")
            this.adjustInstruct.visible = false
        } catch (error) {
            if (error) {
                this.$message.error(`${error}`)
            }
        }
    }
    // 编辑页：基本信息tab详情数据
    async getDetail() {
        try {
            const res: any = await manageService.getVersionDetail({
                product_version_id: this.product_version_id
            })
            this.detailInfo = res || {}
            this.form = res || {}
            this.form.version_type = res.version_type == 1 ? "功能更新" : "bugfix"
        } catch (error) {
            this.$message.error(`${error},获取详情失败！`)
        }
    }
    async getReleaseList() {
        try {
            const res: any = await manageService.getVersionReleaseList({
                product_version_id: this.product_version_id
            })
            const { list = [] } = res || {}
            this.releaseData = cloneDeep(list)
        } catch (error) {
            this.$message.error(`${error},获取列表失败！`)
        }
    }

    async getAdjustScheduleList() {
        try {
            const res: any = await manageService.getAdjustScheduleList({
                product_version_id: this.product_version_id
            })
            const { list = [] } = res || {}
            this.scheduleData = list || []
        } catch (error) {
            this.$message.error(`${error},获取列表失败！`)
        }
    }

    changeTab() {
        if (this.activeTab === "basic") {
            this.getDetail()
        } else if (this.activeTab === "release") {
            this.getReleaseList()
        }
    }
}
